import { Fetch } from '../../shared/types';
import type { Zap, ZDL } from '../types';

type RequestData = {
  zapId: Zap['id'];
  accountId: number;
};

type ResponseData = {
  zap_id: Zap['id'];
  zdl: ZDL;
};

export const publishZap = async (
  fetch: Fetch,
  { zapId, accountId }: RequestData
) =>
  await fetch<ResponseData>(
    `/api/gulliver/storage/v1/zaps/${zapId}/draft/publish-version`,
    {
      params: {
        account_id: accountId,
      },
      method: 'POST',
    }
  );

export default publishZap;
